(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logic-bag-finder"] && !Shopify.designMode) return;
  try {
    
class LogicBagFinder extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.startedAt = performance.now();
    this.dataset.ready = 'false';
    this.words = JSON.parse(this.querySelector('[data-words]').textContent);
    this.controls = this.querySelector('[data-controls]');
    this.grid = this.querySelector('[data-grid]');
    this.status = this.querySelector('[data-status]');
    this.limit = 24;
    this.state = { stamp: '', series: '', variant: '', legacyStandard: false, surface: '', design: '', sport: '', q: '', stock: true, sort: 'created-descending' };
    this.defaultSpeedStyle = this.dataset.speedStyle;
    this.readURL();
    this.syncSpeedStyle();
    this.setupCarousel();
    this.load();
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    clearTimeout(this.searchTimer);
    this.typeRailObserver?.disconnect();
    if (this.popstate) window.removeEventListener('popstate', this.popstate);
  }
  readURL() {
    const params = new URL(location.href).searchParams;
    for (const key of ['stamp','series','variant','surface','design','sport','q']) this.state[key] = params.get('bag_' + key) || '';
    this.state.legacyStandard = false;
    if (!params.has('bag_variant')) {
      const template = this.templateName(params.get('bag_template'));
      const weight = this.variantName(params.get('bag_weight'));
      const stamp = this.stampName(this.state.stamp);
      if (template === 'S') {
        this.state.variant = 'S';
        if (['R','L','H'].includes(weight) && !stamp) this.state.stamp = 'ACL PRO';
      }
      else if (['R','L','H'].includes(weight) && (!stamp || stamp === 'ACL PRO')) {
        // Legacy Weight applied only to ACL PRO, even when All stamps was selected.
        this.state.variant = weight;
        if (!stamp) this.state.stamp = 'ACL PRO';
      } else if (template === 'STANDARD') {
        if (['ACL COMP','ACO'].includes(stamp)) this.state.variant = 'R';
        else if (stamp !== 'ACL PRO') this.state.legacyStandard = true;
      }
    }
    this.state.stock = params.get('bag_stock') !== '0';
    this.state.sort = params.get('sort_by') || 'created-descending';
    this.speedStyle = ['rails','segments','rings'].includes(params.get('bag_display')) ? params.get('bag_display') : this.defaultSpeedStyle;
  }
  syncSpeedStyle() {
    this.dataset.speedStyle = this.speedStyle;
    this.querySelectorAll('[data-speed-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.speedChoice === this.speedStyle)));
  }
  surfaceFor(series) {
    return {element:'hybrid', prism:'hybrid', zinc:'herringbone', rollo:'carpet', 'delta-v':'dual', forza:'dual', strata:'hybrid'}[series] || '';
  }
  async load() {
    this.controls.disabled = true;
    this.dataset.ready = 'false';
    this.dataset.requestCount = '0';
    this.status.textContent = this.words.loading || this.status.textContent;
    try {
      let url = new URL(this.dataset.collection, location.origin);
      url.searchParams.set('view', 'logic-bag-data');
      url.searchParams.set('sort_by', 'best-selling');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const products = [], seenPages = new Set();
      let bootstrap;
      try { bootstrap = JSON.parse(this.querySelector('[data-catalog]')?.textContent || 'null'); } catch { bootstrap = null; }
      const useBootstrap = bootstrap?.complete === true && Array.isArray(bootstrap.products) && !bootstrap.products.some(p => !Array.isArray(p.variants) || p.variantCount > p.variants.length) && (this.state?.sort !== 'best-selling' || bootstrap.sort === 'best-selling');
      if (useBootstrap) {
        products.push(...bootstrap.products);
        url = null;
      }
      this.dataset.source = useBootstrap ? 'inline' : 'request';
      while (url) {
        if (url.origin !== location.origin || seenPages.has(url.href)) throw new Error('Invalid catalog page');
        seenPages.add(url.href);
        this.dataset.requestCount = String(seenPages.size);
        const response = await fetch(url, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Catalog unavailable');
        const page = await response.json();
        if (!Array.isArray(page.products)) throw new Error('Invalid catalog');
        if (page.products.some(p => !Array.isArray(p.variants) || p.variantCount > p.variants.length)) throw new Error('Incomplete variant data');
        products.push(...page.products);
        if (page.next) {
          url = new URL(page.next, location.origin);
          url.searchParams.set('view', 'logic-bag-data');
          url.searchParams.set('sort_by', 'best-selling');
          if (preview) url.searchParams.set('preview_theme_id', preview);
        } else url = null;
      }
      if (!this.isConnected) return;
      this.hasBestSellingRank = !useBootstrap || bootstrap.sort === 'best-selling';
      this.products = [...new Map(products.map(p => [p.id, p])).values()].filter(p => Array.isArray(p.tags) && p.tags.some(tag => tag.toLowerCase() === 'design:catalog'));
      this.products.forEach((p, rank) => {
        p.rank = rank;
        p.searchIndex = this.searchText(p);
        p.designTags = new Set(p.tags.map(tag => tag.toLowerCase()));
        p.variants.forEach(v => Object.assign(v, this.parseVariant(v, p)));
      });
      this.products = this.products.map(p => ({...p, variants:p.variants.filter(v => this.isCurrentVariant(v))})).filter(p => p.variants.length);
      const known = new Set([...this.querySelectorAll('[data-filter="series"]')].map(b => b.dataset.value));
      for (const series of new Set(this.products.flatMap(p => p.variants.map(v => v.series)).filter(Boolean))) {
        if (known.has(series)) continue;
        const button = document.createElement('button'); button.type = 'button'; button.className = 'lbf-option'; button.dataset.filter = 'series'; button.dataset.value = series; button.setAttribute('aria-pressed', 'false');
        const strong = document.createElement('strong'); strong.textContent = series; button.append(strong); this.querySelector('[data-series]').append(button);
      }
      this.controls.disabled = false;
      this.querySelector('[data-fallback]').hidden = true;
      if (!this.bound) { this.bind(); this.bound = true; }
      this.sync();
      this.render();
      this.dataset.ready = 'true';
      this.dataset.productCount = String(this.products.length);
      this.dataset.readyMs = String(Math.round(performance.now() - this.startedAt));
    } catch (error) {
      this.status.textContent = this.words.load_error;
      this.querySelector('[data-retry]').hidden = false;
      this.querySelector('[data-retry]').onclick = () => { this.querySelector('[data-retry]').hidden = true; this.load(); };
    }
  }
  seriesName(value) {
    const match = String(value || '').match(/\b(delta[\s-]?v|element|prism|zinc|rollo|helix|forza|strata)(?:[\s-]*s)?\b/i);
    return match ? match[1].toLowerCase().replace(/delta[\s-]?v/, 'delta-v') : '';
  }
  stampName(value, series = '') {
    const text = String(value ?? '').trim();
    if (/^(?:none|no[\s-]*stamp|unstamped|un[\s-]*stamped)$/i.test(text)) return 'NONE';
    const match = text.match(/\b(ACL[\s-]*(?:PRO|COMP)|ACO)\b/i);
    if (match) return match[1].toUpperCase().replace(/ACL[\s-]*/, 'ACL ');
    // The current catalog uses one ACL option; only these actual series define its level.
    if (/\bACL\b/i.test(text)) {
      if (['rollo','delta-v','forza'].includes(series)) return 'ACL COMP';
      if (['element','zinc','prism'].includes(series)) return 'ACL PRO';
    }
    return '';
  }
  templateName(value) {
    const text = String(value ?? '').trim();
    if (/^(?:s|s[\s-]*(?:template|version)|template[\s-]*s)$/i.test(text)) return 'S';
    if (/^(?:standard|standard[\s-]*template|template[\s-]*standard)$/i.test(text)) return 'STANDARD';
    return '';
  }
  variantName(value) {
    const text = String(value ?? '').trim();
    if (/^(?:s|s[\s-]*(?:template|version)|template[\s-]*s)$/i.test(text)) return 'S';
    const match = text.match(/^([RLH])(?:$|[\s(\-])/i);
    if (match) return match[1].toUpperCase();
    return {regular:'R', standard:'R', light:'L', heavy:'H'}[text.toLowerCase()] || '';
  }
  variantAllowed(stamp, value) {
    if (!value) return true;
    if (value === 'S') return ['ACO','NONE'].includes(stamp);
    if (['L','H'].includes(value)) return ['', 'ACL PRO','NONE'].includes(stamp);
    return value === 'R';
  }
  parseVariant(v, p) {
    const optionValues = (v.options || []).map(option => typeof option === 'object' ? option.value : option).filter(Boolean);
    const namedOptions = Array.isArray(v.selectedOptions) ? v.selectedOptions : (v.options || []).map((option, index) => typeof option === 'object' ? option : {name:typeof p.options?.[index] === 'object' ? p.options[index].name : p.options?.[index], value:option});
    const named = pattern => namedOptions.find(option => pattern.test(option.name || ''))?.value;
    const text = [v.title || '', ...optionValues, ...namedOptions.map(option => option.value || '')].join(' / ');
    const tags = Array.isArray(p.tags) ? p.tags : [];
    const metadata = v.metadata || {};
    let series = this.seriesName(v.series || metadata.series || named(/^(?:bag[\s_-]*)?series$/i)) || this.seriesName(text);
    if (!series) {
      const seriesTags = [...new Set(tags.filter(tag => /^(?:series:)?(?:element|prism|zinc|rollo|helix|forza|strata|delta[ -]?v)$/i.test(tag)).map(tag => this.seriesName(tag)))];
      if (seriesTags.length === 1) series = seriesTags[0];
    }
    const stampValue = v.stamp ?? v.certification ?? metadata.stamp ?? metadata.certification ?? named(/^(?:stamp|certification|approval)$/i);
    const explicitStamp = this.stampName(stampValue, series);
    // Explicit Unstamped always wins over broad product-level approval tags.
    const textStamp = /\b(?:un[\s-]*stamped|no[\s-]*stamp)\b/i.test(text) || text.split(/\s*\/\s*/).some(value => /^none$/i.test(value)) ? 'NONE' : this.stampName(text, series);
    let stamp = explicitStamp || textStamp;
    // An unclassifiable ACL variant must not inherit an unrelated product-level stamp.
    if (!stamp && !/\bACL\b/i.test([stampValue || '', text].join(' / '))) {
      const stampTags = [...new Set(tags.filter(tag => /^(?:stamp:|certification:)?(?:ACL[ -]*(?:PRO|COMP)|ACO)$/i.test(tag)).map(tag => this.stampName(tag)))];
      // A missing stamp is unknown, never a synonym for Unstamped.
      if (stampTags.length === 1) stamp = stampTags[0];
    }
    let template = this.templateName(v.template ?? metadata.template ?? named(/^(?:bag[\s_-]*)?template$/i));
    if (!template) {
      if (/\b(?:element|prism|zinc|rollo|helix|forza|strata|delta[\s-]?v)[\s-]*s\b/i.test(text) || /(?:^|[\s/(-])s(?:[\s/)-]|$)/i.test(text)) template = 'S';
      else if (/\bstandard\b/i.test(text)) template = 'STANDARD';
      // Existing named non-S series use the legacy Standard template.
      else if (this.seriesName(text)) template = 'STANDARD';
    }
    const weightValue = String(v.weight || metadata.weight || named(/^weight$/i) || '');
    const weightMatch = weightValue.match(/^[RLH]$/i) || text.match(/(?:^|[\s/\-])([RLH])(?=[\s(\-/]|$)/i);
    const weight = weightMatch ? (weightMatch[1] || weightMatch[0]).toUpperCase() : (['rollo','delta-v','forza'].includes(series) ? 'R' : '');
    const explicitVariant = this.variantName(v.variant ?? metadata.variant ?? named(/^(?:variant|size(?: or weight)?|weight(?: or variant)?)$/i));
    const textVariant = this.variantName(text.split(/\s*\/\s*/).find(value => /^(?:regular|light|heavy)$/i.test(value)));
    // Standard names in the ACO/Unstamped catalog mean R; absent ACL PRO weight stays unknown.
    const variant = explicitVariant || (template === 'S' ? 'S' : textVariant || weight || (template === 'STANDARD' && ['ACO','NONE','ACL COMP'].includes(stamp) ? 'R' : ''));
    return {series, stamp, template, weight, variant};
  }
  seriesAllowed(stamp, series) {
    const current = {
      'ACL PRO':['element','zinc','prism'],
      'ACL COMP':['rollo','delta-v','forza'],
      ACO:['element','zinc','prism','forza','strata']
    };
    return !series || (current[stamp] || ['element','zinc','prism','rollo','delta-v','forza','strata']).includes(series);
  }
  isCurrentVariant(v) {
    if (!v.series || !this.seriesAllowed(v.stamp, v.series)) return false;
    return !v.variant || this.variantAllowed(v.stamp, v.variant);
  }
  hasSeries(series, stamp = this.state.stamp) {
    // Certification eligibility is independent of stock and the optional design/variant filters.
    // Intersect the current approval matrix with real catalog variants; never invent an offer.
    return this.seriesAllowed(stamp, series) && this.products.some(p => p.variants.some(v => this.isCurrentVariant(v) && v.series === series && (!stamp || v.stamp === stamp)));
  }
  matches(v, state = this.state) {
    return this.isCurrentVariant(v) && (!state.stamp || v.stamp === state.stamp) && (!state.series || v.series === state.series) && (!state.variant || v.variant === state.variant) && (!state.legacyStandard || v.template === 'STANDARD') && (!state.surface || this.surfaceFor(v.series) === state.surface) && (!state.stock || v.available === true);
  }
  searchText(p) {
    if (typeof p.searchIndex === 'string') return p.searchIndex;
    const colors = Array.isArray(p.colors) ? p.colors : [];
    const aliases = colors.map(color => color.toLowerCase().replace(/\bnavy\b/g, 'navy blue').replace(/\b(aqua|teal)\b/g, '$1 blue turquoise').replace(/\bgrey\b/g, 'grey gray').replace(/\bgray\b/g, 'gray grey').replace(/\bburgundy\b/g, 'burgundy red').replace(/\bivory\b/g, 'ivory cream beige').replace(/\bpewter\b/g, 'pewter gray grey'));
    return (p.title + ' ' + p.tags.filter(t => !t.toLowerCase().startsWith('design:')).join(' ') + ' ' + aliases.join(' ')).toLowerCase();
  }
  matchesDesign(p, state = this.state) {
    const tags = p.designTags || new Set(p.tags.map(tag => tag.toLowerCase()));
    return (!state.design || tags.has('design:' + state.design)) && (state.design !== 'sports' || !state.sport || tags.has('design:' + state.sport));
  }
  normalize() {
    const designs = ['sports','usa','skeleton','minimalist','grunge','graffiti','halloween','nature','retro','tech','animals','monochrome','hmong','collaborations','custom','throwdown','logo'];
    this.state.stamp = this.stampName(this.state.stamp);
    this.state.series = this.seriesName(this.state.series);
    if (this.state.series === 'helix') this.state.series = '';
    this.state.variant = this.variantName(this.state.variant);
    if (this.state.design && !designs.includes(this.state.design)) this.state.design = '';
    if (this.state.design !== 'sports' || !['football','baseball','soccer'].includes(this.state.sport)) this.state.sport = '';
    if (!['','hybrid','herringbone','carpet','dual'].includes(this.state.surface || '')) this.state.surface = '';
    if (!['created-descending','best-selling','price-ascending','price-descending','title-ascending','created-ascending'].includes(this.state.sort)) this.state.sort = 'created-descending';
    if ((this.state.stamp === 'ACO' && this.dataset.showAco !== 'true') || (this.state.stamp === 'NONE' && this.dataset.showNone !== 'true')) this.state.stamp = '';
    // Invalid saved stamp/variant pairs cannot be offered; keep S across ACO/Unstamped.
    if (this.state.stamp && this.state.variant && !this.variantAllowed(this.state.stamp, this.state.variant)) this.state.variant = '';
    // Remove stale series from stamp changes or old links, while retaining valid sold-out
    // series and genuine variant/surface combinations for honest stock-filtered results.
    if (this.state.series && (!this.seriesAllowed(this.state.stamp, this.state.series) || (this.products && !this.hasSeries(this.state.series)))) this.state.series = '';
  }
  setFilter(key, value) {
    this.state[key] = value;
    if (key === 'variant') this.state.legacyStandard = false;
    if (key === 'stamp' && !this.variantAllowed(this.stampName(value), this.state.variant)) this.state.variant = '';
    if (key === 'design') this.state.sport = '';
    this.normalize();
  }
  bind() {
    this.addEventListener('click', event => {
      const choice = event.target.closest('[data-speed-choice]');
      if (choice) {
        this.speedStyle = choice.dataset.speedChoice;
        this.syncSpeedStyle();
        const url = new URL(location.href); url.searchParams.set('bag_display', this.speedStyle);
        history.replaceState(null, '', url);
      }
      const button = event.target.closest('[data-filter]');
      if (button && !button.disabled && !button.hidden) {
        const key = button.dataset.filter;
        this.setFilter(key, button.dataset.value);
        this.change();
      }
      if (event.target.closest('[data-reset]')) {
        this.state = { stamp:'', series:'', variant:'', legacyStandard:false, surface:'', design:'', sport:'', q:'', stock:true, sort:this.state.sort };
        this.change();
      }
      if (event.target.closest('[data-type-prev],[data-type-next]')) {
        const rail = this.querySelector('[data-type-rail]');
        rail.scrollBy({left:Math.max(180, rail.clientWidth * .75) * (event.target.closest('[data-type-prev]') ? -1 : 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      if (event.target.closest('[data-design-prev],[data-design-next]')) {
        const rail = this.querySelector('[data-design-rail]');
        rail.scrollBy({left:Math.max(240, rail.clientWidth * .7) * (event.target.closest('[data-design-prev]') ? -1 : 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      if (event.target.closest('[data-more]')) { this.limit += 24; this.render(); }
    });
    this.querySelector('[data-search]').addEventListener('input', event => {
      this.state.q = event.target.value;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.change(true), 180);
    });
    this.querySelector('[data-stock]').addEventListener('change', event => { this.state.stock = event.target.checked; this.change(); });
    this.querySelector('[data-sort]').addEventListener('change', event => {
      this.state.sort = event.target.value;
      if (this.state.sort === 'best-selling' && !this.hasBestSellingRank) { this.limit = 24; this.updateURL(); this.load(); }
      else this.change();
    });
    this.popstate = () => {
      this.readURL(); this.syncSpeedStyle(); this.limit = 24;
      if (this.state.sort === 'best-selling' && !this.hasBestSellingRank) this.load();
      else { this.sync(); this.render(); }
    };
    window.addEventListener('popstate', this.popstate);
    this.setupTypeCarousel();
  }
  change(replace = false) {
    this.limit = 24;
    this.sync();
    this.render();
    this.updateURL(replace);
  }
  updateURL(replace = false) {
    const url = new URL(location.href);
    for (const key of ['stamp','series','variant','surface','design','sport','q']) {
      if (this.state[key]) url.searchParams.set('bag_' + key, this.state[key]);
      else url.searchParams.delete('bag_' + key);
    }
    url.searchParams.delete('bag_weight');
    if (this.state.legacyStandard) url.searchParams.set('bag_template', 'STANDARD'); else url.searchParams.delete('bag_template');
    if (this.state.stock) url.searchParams.delete('bag_stock'); else url.searchParams.set('bag_stock', '0');
    url.searchParams.set('sort_by', this.state.sort);
    url.searchParams.delete('page');
    if (url.href !== location.href) history[replace ? 'replaceState' : 'pushState'](null, '', url);
  }
  sync() {
    const previousSeries = this.state.series, previousVariant = this.state.variant;
    this.normalize();
    // Canonicalize invalid saved links without adding a second history entry.
    if ((previousSeries && !this.state.series) || (previousVariant && !this.state.variant)) this.updateURL(true);
    this.querySelector('[data-sport-options]').hidden = this.state.design !== 'sports';
    const note = this.querySelector('[data-variant-note]');
    note.textContent = this.state.legacyStandard ? 'Showing Standard variants from this saved link. Choose a Variant to update it.' : this.state.variant === 'S' && !['ACO','NONE'].includes(this.state.stamp) ? 'S is available with ACO or Unstamped. Choose a stamp to refine this selection.' : this.state.variant && !this.variantAllowed(this.state.stamp, this.state.variant) ? 'This variant is not offered with the selected stamp. Choose another Variant.' : '';
    note.hidden = !note.textContent;
    const extraCount = ['surface','design','sport'].filter(key => this.state[key]).length;
    this.querySelector('[data-extra-count]').textContent = extraCount ? `(${extraCount} active)` : '';
    if (extraCount) this.querySelector('[data-more-filters]').open = true;
    this.querySelector('[data-search]').value = this.state.q;
    this.querySelector('[data-stock]').checked = this.state.stock;
    this.querySelector('[data-sort]').value = this.state.sort;
    this.querySelectorAll('[data-filter]').forEach(button => {
      const key = button.dataset.filter, value = button.dataset.value;
      button.setAttribute('aria-pressed', String(this.state[key] === value));
      if (key === 'series') button.hidden = !!value && !this.hasSeries(value);
      if (['surface','series'].includes(key)) {
        const candidate = {...this.state, [key]:value, stock:key === 'series' ? this.state.stock : false, q:'', design:'', sport:''};
        button.disabled = button.hidden || (!!value && value !== this.state[key] && !this.products.some(p => p.variants.some(v => this.matches(v, candidate))));
      }
      // Certification remains selectable even before matching designs are listed.
      if (key === 'stamp') button.disabled = false;
      if (key === 'variant') {
        const allowed = this.variantAllowed(this.state.stamp, value);
        const hasVariant = !['L','H'].includes(value) || this.products.some(p => p.variants.some(v => this.matches(v, {...this.state, variant:value, stock:false, legacyStandard:false})));
        button.hidden = !!value && value !== this.state.variant && (!allowed || !hasVariant);
        button.disabled = !!value && (!allowed || !hasVariant);
        button.title = button.disabled ? 'Choose a compatible stamp or series' : '';
      }
    });
    const typeRail = this.querySelector('[data-type-rail]');
    const selectedType = typeRail.querySelector('[aria-pressed="true"]');
    if (selectedType) {
      const railBounds = typeRail.getBoundingClientRect(), selectedBounds = selectedType.getBoundingClientRect();
      const offset = selectedBounds.left < railBounds.left ? selectedBounds.left - railBounds.left - 4 : selectedBounds.right > railBounds.right ? selectedBounds.right - railBounds.right + 4 : 0;
      if (offset) typeRail.scrollBy({left:offset, behavior:'auto'});
    }
  }
  selection(p) {
    const variants = p.variants.filter(v => this.matches(v));
    if (!variants.length) return null;
    variants.sort((a,b) => Number(b.available) - Number(a.available) || a.price - b.price);
    const v = variants[0];
    return {p, v, variants};
  }
  render() {
    const terms = this.state.q.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const eligible = this.products.filter(p => terms.every(term => this.searchText(p).includes(term))).map(p => this.selection(p)).filter(Boolean);
    const rows = eligible.filter(row => this.matchesDesign(row.p));
    this.querySelectorAll('[data-design-count]').forEach(count => {
      const total = eligible.filter(row => this.matchesDesign(row.p, {design:count.dataset.designCount})).length;
      count.textContent = total;
    });
    const sort = this.state.sort;
    rows.sort((a,b) => {
      if (sort === 'price-ascending') return a.v.price - b.v.price;
      if (sort === 'price-descending') return b.v.price - a.v.price;
      if (sort === 'title-ascending') return a.p.title.localeCompare(b.p.title);
      if (sort === 'created-ascending') return Number(a.p.created) - Number(b.p.created);
      if (sort === 'best-selling') return a.p.rank - b.p.rank;
      return Number(b.p.created) - Number(a.p.created);
    });
    const fragment = document.createDocumentFragment();
    rows.slice(0, this.limit).forEach(row => fragment.append(this.card(row)));
    this.grid.replaceChildren(fragment);
    this.status.textContent = this.words.results.replace('[count]', rows.length).replace('[total]', this.products.length);
    this.querySelector('[data-empty]').hidden = rows.length > 0;
    this.querySelector('[data-custom-empty]').hidden = rows.length > 0 || (!['ACO','NONE'].includes(this.state.stamp) && this.state.variant !== 'S');
    this.querySelector('[data-more]').hidden = rows.length <= this.limit;
    this.querySelector('[data-shown]').textContent = rows.length ? this.words.shown.replace('[count]', Math.min(this.limit, rows.length)).replace('[total]', rows.length) : '';
  }
  card({p, v, variants}) {
    const li = document.createElement('li'); li.className = 'lbf-card';
    const a = document.createElement('a');
    const url = new URL(p.url, location.origin); url.searchParams.set('variant', v.id);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    a.href = url.pathname + url.search; a.className = 'lbf-card-link';
    const media = document.createElement('div'); media.className = 'lbf-card-media';
    if (v.image || p.image) {
      const img = document.createElement('img'); img.src = v.image || p.image; img.alt = p.title + ' — ' + v.title; img.width = 600; img.height = 600; img.loading = 'lazy'; media.append(img);
    }
    
    a.append(media);
    const content = document.createElement('div'); content.className = 'lbf-card-content';
    const heading = document.createElement('h3');
    heading.textContent = p.title.replace(/\s*-\s*(?:ACL\s|Halloween Cornhole Bags|Multiple Bag Series|Logic Cornhole ACL).*$/i, '').replace(/\s*-\s*Set of 4.*$/i, '');
    const label = {element:'Element', zinc:'Zinc', prism:'Prism', rollo:'Rollo', 'delta-v':'Delta-V', forza:'Forza', strata:'Strata'};
    const parts = [label[v.series] || v.series, v.stamp === 'NONE' ? 'Unstamped' : v.stamp || 'Stamp not specified', {R:'R (Regular)', L:'L (Light)', H:'H (Heavy)', S:'S (Smaller variant)'}[v.variant] || 'Variant not specified'];
    const multipleSeries = !this.state.series && new Set(variants.map(variant => variant.series)).size > 1;
    const detail = document.createElement('p'); detail.className = 'lbf-variant'; detail.textContent = multipleSeries ? 'Available in multiple series' : parts.join(' · ');
    const selected = document.createElement('p'); selected.className = 'lbf-card-selection'; selected.textContent = 'Shown: ' + parts.join(' · ');
    li.dataset.variantId = String(v.id); li.dataset.series = v.series; li.dataset.stamp = v.stamp; li.dataset.template = v.template; li.dataset.variant = v.variant;
    const price = document.createElement('p'); price.className = 'lbf-price';
    price.textContent = v.money;
    if (v.compare > v.price) { const old = document.createElement('s'); old.textContent = v.compareMoney; price.append(' ', old); }
    const availability = document.createElement('p'); availability.className = 'lbf-availability' + (v.available ? '' : ' lbf-sold-out'); availability.textContent = v.available ? this.words.available : this.words.sold_out;
    const action = document.createElement('span'); action.className = 'lbf-card-action'; action.textContent = this.words.view + ' ↗';
    content.append(heading, detail); if (multipleSeries) content.append(selected); content.append(price); if (!v.available) content.append(availability); content.append(action); a.append(content); li.append(a);
    return li;
  }
  setupTypeCarousel() {
    const rail = this.querySelector('[data-type-rail]');
    const update = () => {
      const overflow = rail.scrollWidth - rail.clientWidth;
      this.querySelector('[data-type-arrows]').hidden = overflow <= 1;
      this.querySelector('[data-type-prev]').disabled = rail.scrollLeft <= 1;
      this.querySelector('[data-type-next]').disabled = rail.scrollLeft >= overflow - 1;
    };
    rail.addEventListener('scroll', update, {passive:true});
    this.typeRailObserver = new ResizeObserver(update);
    this.typeRailObserver.observe(rail);
    update();
  }
  setupCarousel() {
    const slides = [...this.querySelectorAll('[data-slide]')];
    if (slides.length < 2) return;
    let index = 0, paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pause = this.querySelector('[data-pause]');
    const show = n => {
      index = (n + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      this.querySelector('[data-slide-count]').textContent = `${index + 1} / ${slides.length}`;
    };
    const update = () => {
      clearInterval(this.timer);
      pause.textContent = paused ? this.words.play : this.words.pause;
      pause.setAttribute('aria-pressed', String(paused));
      if (!paused) this.timer = setInterval(() => { if (!document.hidden && !this.querySelector('[data-carousel]').matches(':hover,:focus-within')) show(index + 1); }, 6500);
    };
    this.querySelector('[data-prev]').onclick = () => show(index - 1);
    this.querySelector('[data-next]').onclick = () => show(index + 1);
    pause.onclick = () => { paused = !paused; update(); };
    let touchX;
    const carousel = this.querySelector('[data-carousel]');
    carousel.addEventListener('touchstart', e => { touchX = e.changedTouches[0].clientX; }, {passive:true});
    carousel.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - touchX; if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1)); }, {passive:true});
    show(0); update();
  }
}
if (!customElements.get('logic-bag-finder')) customElements.define('logic-bag-finder', LogicBagFinder);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logic-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('logic-focus-carousel')) {
  customElements.define('logic-focus-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = Array.from(this.querySelectorAll('[data-focus-slide]'));
      if (this.slides.length < 2) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.index = 0;
      this.hovered = window.matchMedia('(hover: hover)').matches && this.matches(':hover');
      this.focused = this.contains(document.activeElement);
      this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.media.matches;
      this.track = this.querySelector('.lh-focus-track');
      this.dots = Array.from(this.querySelectorAll('[data-focus-dot]'));
      this.pauseButton = this.querySelector('[data-focus-pause]');
      this.querySelector('.lh-focus-controls').hidden = false;
      this.querySelector('[data-focus-prev]').addEventListener('click', () => this.show(this.index - 1), { signal });
      this.querySelector('[data-focus-next]').addEventListener('click', () => this.show(this.index + 1), { signal });
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), { signal }));
      this.pauseButton.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updatePlayback();
      }, { signal });
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.updatePlayback();
      }, { signal });
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.updatePlayback();
      }, { signal });
      this.addEventListener('focusin', () => {
        this.focused = true;
        this.updatePlayback();
      }, { signal });
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.events) return;
          this.focused = this.contains(document.activeElement);
          this.updatePlayback();
        });
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const focusIsOnSlide = event.target.closest('[data-focus-slide]');
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        if (focusIsOnSlide) this.slides[this.index].focus({ preventScroll: true });
      }, { signal });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
      this.media.addEventListener('change', () => {
        if (this.media.matches) this.userPaused = true;
        this.updatePlayback();
      }, { signal });
      this.show(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.events = null;
    }
    show(nextIndex) {
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      // Warm the upcoming image before the fast hero rotation reveals it.
      [this.slides[this.index], this.slides[(this.index + 1) % this.slides.length]].forEach((slide) => {
        slide.querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
      });
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
        }
      });
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.index);
        dot.setAttribute('aria-pressed', String(index === this.index));
      });
      this.updatePlayback();
    }
    updatePlayback() {
      clearTimeout(this.timer);
      const paused = this.userPaused || this.hovered || this.focused || document.hidden;
      this.pauseButton.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.pauseButton.querySelector('span').textContent = this.userPaused ? '▷' : 'Ⅱ';
      this.track.setAttribute('aria-live', paused ? 'polite' : 'off');
      if (!paused && this.isConnected) {
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 4000);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
